// extracted by mini-css-extract-plugin
export default {"description":"_fb3d6882"};